import { type StoreApi, type UseBoundStore } from 'zustand';
import { type EditableFormValues } from 'individual/components/BackgroundInfo/EditableForm';
import { type BackgroundInfoForm } from 'individual/types/backgroundInfoForm';

type WithSelectors<S> = S extends { getState: () => infer T }
  ? S & { use: { [K in keyof T]: () => T[K] } }
  : never;

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(
  _store: S
) => {
  const store = _store as WithSelectors<typeof _store>;
  store.use = {};
  for (const k of Object.keys(store.getState())) {
    (store.use as any)[k] = () => store((s) => s[k as keyof typeof s]);
  }

  return store;
};

export function toEditableForm(
  formValues: BackgroundInfoForm
): EditableFormValues {
  return {
    ...formValues,
    children: formValues.children ?? 0,
    monthlyIncome: formValues.monthlyIncome?.toString() ?? '',
    debt: formValues.debt?.toString() ?? '',
    dateOfBirth: formValues.dateOfBirth
      ? new Date(formValues.dateOfBirth)
      : undefined,
    smokingStatus: formValues.smokingStatus,
  };
}
